import { render, staticRenderFns } from "./ViewLogin.vue?vue&type=template&id=4bbd7e20&"
import script from "./ViewLogin.vue?vue&type=script&lang=js&"
export * from "./ViewLogin.vue?vue&type=script&lang=js&"
import style0 from "./ViewLogin.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports